import { render, staticRenderFns } from "./clueRole.vue?vue&type=template&id=33f45fe0&scoped=true"
import script from "./clueRole.vue?vue&type=script&lang=js"
export * from "./clueRole.vue?vue&type=script&lang=js"
import style0 from "./clueRole.vue?vue&type=style&index=0&id=33f45fe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f45fe0",
  null
  
)

export default component.exports